import { FarmNftItemV2 } from "./FarmNftItemV2";
import { FarmNftMinterV2 } from "./FarmNftMinterV2";

export const FARM = {
  NftItem: FarmNftItemV2,
  NftMinter: FarmNftMinterV2,
} as const;
